import React from "react";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {ActionRow, ActionRowButton, Icon, SimpleCardHeading} from "peggirkit";
import {ArrowRightEndOnRectangleIcon} from "@heroicons/react/24/solid";
import {FormattedMessage} from "react-intl";
import {EmployeeDashboardProps} from "@widgets/timeRegistration/EmployeeDashboard";



const EmployeeCardHeader = ({setEmployee}: EmployeeDashboardProps) => {
    return (
        <CardHeader
            actionRow={
                <ActionRow useMoreButton={false}>
                    <ActionRowButton
                        buttonAction={{
                            as: "button",
                            actionProps: {
                                onClick: () => setEmployee(null),
                            },
                        }}
                        showInRowBreakpoint="alwaysInMore"
                        iconAfter={<Icon icon={ArrowRightEndOnRectangleIcon}/>}
                        color="danger"
                        variant="outline"
                        size={"xs"}
                    >
                        <FormattedMessage id={"signOut"}/>
                    </ActionRowButton>
                </ActionRow>
            }
        >
            <SimpleCardHeading
                title={<FormattedMessage id={"timeRegistration"}/>}
            />
        </CardHeader>
    );
};

export default EmployeeCardHeader;